import React from 'react';
const SelectUserType: any = dynamic(
  () => import('features/auth/components/select_user_type/SelectUserType')
);
const AuthenticatedLayout: any = dynamic(
  () => import('sharedui/components/commons/AuthenticatedLayout'),
  {
    ssr: false,
  }
);
import dynamic from 'next/dynamic';
import { NextPageWithLayout } from 'pages/page';
import Head from 'next/head';
import { OthersAuthRedirection } from 'sharedui/functions/handleServerAuth';

const Index: NextPageWithLayout = () => {
  return (
    <AuthenticatedLayout>
      <SelectUserType />
    </AuthenticatedLayout>
  );
};

Index.getLayout = function (page: any) {
  return (
    <>
      <Head>
        <meta
          name="viewport"
          content="initial-scale=1.0, width=device-width"
          key="title"
        />
        <title>Select User Type</title>
      </Head>
      {page}
    </>
  );
};

export const getServerSideProps = (appContext: any) => {
  const {
    USER_ROLE_COOKIE,
    KYC_STATUS_COOKIE,
    IS_STRIPE_COOKIE,
    ACCOUNT_TYPE_COOKIE,
  } = appContext.req.cookies;

  const redirectDestination = OthersAuthRedirection({
    ACCOUNT_TYPE_COOKIE,
    IS_STRIPE_COOKIE,
    KYC_STATUS_COOKIE,
    USER_ROLE_COOKIE,
  });
  if (redirectDestination) {
    return {
      redirect: {
        destination: redirectDestination,
        permanent: false,
      },
    };
  }
  const props = {
    kycStatus: KYC_STATUS_COOKIE,
    userRole: USER_ROLE_COOKIE,
    isStripe: IS_STRIPE_COOKIE,
    accountType: ACCOUNT_TYPE_COOKIE,
  };
  // Check if userRole is undefined
  if (typeof USER_ROLE_COOKIE === 'undefined') {
    return {
      props: {},
    };
  }

  return {
    props,
  };
};

export default Index;
